'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var Scope =
/*#__PURE__*/
function () {
  function Scope() {
    _classCallCheck(this, Scope);
  }

  _createClass(Scope, [{
    key: "active",
    value: function active() {
      return this._active() || null;
    }
  }, {
    key: "activate",
    value: function activate(span, callback) {
      if (typeof callback !== 'function') return callback;

      try {
        return this._activate(span, callback);
      } catch (e) {
        if (span && typeof span.setTag === 'function') {
          span.setTag('error', e);
        }

        throw e;
      }
    }
  }, {
    key: "bind",
    value: function bind(target, span) {
      target = this._bindEmitter(target, span);
      target = this._bindPromise(target, span);
      target = this._bindFn(target, span);
      return target;
    }
  }, {
    key: "unbind",
    value: function unbind(target) {
      target = this._unbindFn(target);
      target = this._unbindPromise(target);
      target = this._unbindEmitter(target);
      return target;
    }
  }, {
    key: "_active",
    value: function _active() {
      return null;
    }
  }, {
    key: "_activate",
    value: function _activate(span, callback) {
      return callback();
    }
  }, {
    key: "_bindFn",
    value: function _bindFn(fn, span) {
      if (typeof fn !== 'function') return fn;
      var scope = this;

      var spanOrActive = this._spanOrActive(span);

      var bound = function bound() {
        var _this = this,
            _arguments = arguments;

        return scope.activate(spanOrActive, function () {
          return fn.apply(_this, _arguments);
        });
      };

      bound._datadog_unbound = fn;
      return bound;
    }
  }, {
    key: "_unbindFn",
    value: function _unbindFn(fn) {
      if (typeof fn !== 'function') return fn;
      return fn._datadog_unbound || fn;
    }
  }, {
    key: "_bindEmitter",
    value: function _bindEmitter(emitter, span) {
      if (!this._isEmitter(emitter)) return emitter;
      wrapMethod(emitter, 'addListener', wrapAddListener, this, span);
      wrapMethod(emitter, 'prependListener', wrapAddListener, this, span);
      wrapMethod(emitter, 'on', wrapAddListener, this, span);
      wrapMethod(emitter, 'once', wrapAddListener, this, span);
      wrapMethod(emitter, 'prependOnceListener', wrapAddListener, this, span);
      wrapMethod(emitter, 'removeListener', wrapRemoveListener);
      wrapMethod(emitter, 'off', wrapRemoveListener);
      wrapMethod(emitter, 'removeAllListeners', wrapRemoveAllListeners);
      return emitter;
    }
  }, {
    key: "_unbindEmitter",
    value: function _unbindEmitter(emitter) {
      if (!this._isEmitter(emitter)) return emitter;
      unwrapMethod(emitter, 'addListener');
      unwrapMethod(emitter, 'prependListener');
      unwrapMethod(emitter, 'on');
      unwrapMethod(emitter, 'once');
      unwrapMethod(emitter, 'prependOnceListener');
      return emitter;
    }
  }, {
    key: "_bindPromise",
    value: function _bindPromise(promise, span) {
      if (!this._isPromise(promise)) return promise;
      wrapMethod(promise, 'then', wrapThen, this, span);
      return promise;
    }
  }, {
    key: "_unbindPromise",
    value: function _unbindPromise(promise) {
      if (!this._isPromise(promise)) return promise;
      promise.then = promise.then._datadog_unbound || promise.then;
      return promise;
    }
  }, {
    key: "_spanOrActive",
    value: function _spanOrActive(span) {
      return span !== undefined ? span : this.active();
    }
  }, {
    key: "_isEmitter",
    value: function _isEmitter(emitter) {
      return emitter && typeof emitter.emit === 'function' && typeof emitter.on === 'function' && typeof emitter.addListener === 'function' && typeof emitter.removeListener === 'function';
    }
  }, {
    key: "_isPromise",
    value: function _isPromise(promise) {
      return promise && typeof promise.then === 'function';
    }
  }]);

  return Scope;
}();

function wrapThen(then, scope, span) {
  return function thenWithTrace(onFulfilled, onRejected) {
    var args = new Array(arguments.length);

    for (var i = 0, l = args.length; i < l; i++) {
      args[i] = scope.bind(arguments[i], span);
    }

    return then.apply(this, args);
  };
}

function wrapAddListener(addListener, scope, span) {
  return function addListenerWithTrace(eventName, listener) {
    if (!listener || listener._datadog_unbound || listener.listener) {
      return addListener.apply(this, arguments);
    }

    var bound = scope.bind(listener, scope._spanOrActive(span));
    this._datadog_events = this._datadog_events || {};

    if (!this._datadog_events[eventName]) {
      this._datadog_events[eventName] = new WeakMap();
    }

    var events = this._datadog_events[eventName];

    if (!events.has(listener)) {
      events.set(listener, []);
    }

    events.get(listener).push(bound);
    return addListener.call(this, eventName, bound);
  };
}

function wrapRemoveListener(removeListener) {
  return function removeListenerWithTrace(eventName, listener) {
    var listeners = this._datadog_events && this._datadog_events[eventName];

    if (!listener || !listeners || !listeners.has(listener)) {
      return removeListener.apply(this, arguments);
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = listeners.get(listener)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var bound = _step.value;
        removeListener.call(this, eventName, bound);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    listeners.delete(listener);
    return removeListener.call(this, eventName, listener);
  };
}

function wrapRemoveAllListeners(removeAllListeners) {
  return function removeAllListenersWithTrace(eventName) {
    if (this._datadog_events) {
      if (eventName) {
        delete this._datadog_events[eventName];
      } else {
        delete this._datadog_events;
      }
    }

    return removeAllListeners.call(this, eventName);
  };
}

function wrapMethod(target, name, wrapper) {
  if (!target[name] || target[name]._datadog_unbound) return;
  var original = target[name];

  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  target[name] = wrapper.apply(void 0, [target[name]].concat(args));
  target[name]._datadog_unbound = original;
}

function unwrapMethod(target, name) {
  if (!target[name] || !target[name]._datadog_unbound) return;
  target[name] = target[name]._datadog_unbound;
}

module.exports = Scope;